// CC: taken from apply-policy.component.ts, simplified for onboarding wizard (single page: dropdown for source admin + policy grid)
import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import {GeneralService} from '../../../services/generalService';
import {RouteService} from '../../../services/routeService';
import {NotificationService} from '../../../services/notificationService';
import {DICTIONARY} from '../../../dictionary';

@Component({
	selector: 'onboarding-copy-policy-component',
	templateUrl: './onboarding-copy-policy.component.html',
})
export class OnboardingCopyPolicyComponent implements OnInit {
	@Output() done = new EventEmitter<void>();

	dic = DICTIONARY;
	applyInProcess = false;

	// CC: taken from apply-policy.component.ts -> admin list
	fromAdmins = [];
	selectedFromAdmin;

	// CC: taken from apply-policy.component.ts -> policy templates
	planPolicyTemplates = [];
	selectedPolicyTemplate;

	// CC: taken from apply-policy.component.ts -> installPolicyData.appendMode
	appendMode = true;

	// CC: taken from apply-policy.component.ts -> installPolicyData.policy
	policy = {
		inbound: {
			rules: false,
			inbound_email_rules: false,
			phishing_bypass: false,
			url_rewrite: false,
			url_tracking: false,
			smart_banner: false,
			senders_whitelist: false,
			senders_whitelist_advanced: false,
			personal_list_settings: false,
			senders_blacklist: false,
			links_whitelist: false,
			links_blacklist: false,
			attachments_whitelist: false,
			attachments_blacklist: false,
			block_files_types: false,
			block_files_types_extensions: false
		},
		outbound: {
			rules: false,
			policy: false,
			enforce_domain: false,
			outbound_reviewers_quarantine_notifications: false,
			welcome_email: false
		},
		accountTakeover: {
			incident_types: false,
			rules: false,
		},
		domainProtection: {
			domain_impersonation_enabled: false
		},
		threatSimulation: {
			templates: false,
			materials: false,
		}
	};

	constructor(public gs: GeneralService,
				private rs: RouteService,
				private ns: NotificationService) {
	}

	ngOnInit() {
		this.fromAdmins = (this.gs.planAdmins || []).map(adminObj => ({
			email: adminObj.email,
			name: adminObj.company_name || adminObj.alloc_plan_id?.company_name || adminObj.user_id?.name || adminObj.email,
		}));
		// CC: pre-select the current controlAdmin
		this.selectedFromAdmin = this.fromAdmins.find(admin => admin.email === this.gs.controlAdmin?.email);

		this.rs.getInstallPolicies().then((response) => {
			this.planPolicyTemplates = response || [];
		});
	}

	selectAdmin = (adminObj) => {
		this.selectedFromAdmin = adminObj;
	}

	// CC: taken from apply-policy.component.ts -> selectPolicyTemplate
	selectPolicyTemplate = (policyObj) => {
		this.selectedPolicyTemplate = policyObj;
		Object.keys(policyObj).forEach((categoryKey) => {
			if (this.policy[categoryKey]) {
				Object.keys(this.policy[categoryKey] || {}).forEach((modelKey) => {
					this.policy[categoryKey][modelKey] = !!policyObj[categoryKey][modelKey];
				});
			}
		});
	}

	// CC: taken from apply-policy.component.ts -> selectAllPolicies
	selectAllPolicies = () => {
		const isAllSelected = Object.keys(this.policy).every((categoryKey) => {
			return Object.keys(this.policy[categoryKey] || {}).every((modelKey) => {
				return this.policy[categoryKey][modelKey];
			});
		});
		Object.keys(this.policy).forEach((categoryKey) => {
			Object.keys(this.policy[categoryKey] || {}).forEach((modelKey) => {
				this.policy[categoryKey][modelKey] = !isAllSelected;
			});
		});
	}

	// CC: taken from apply-policy.component.ts -> checkPolicySelected
	checkPolicySelected = () => {
		return Object.keys(this.policy).some((categoryKey) => {
			return Object.keys(this.policy[categoryKey] || {}).some((modelKey) => {
				return this.policy[categoryKey][modelKey];
			});
		});
	}

	// CC: taken from apply-policy.component.ts -> installPolicyExecute
	applyPolicy = () => {
		if (this.applyInProcess) {
			return;
		}

		if (!this.selectedFromAdmin) {
			this.ns.showWarnMessage('Please select a source plan');
			return;
		}

		if (!this.checkPolicySelected()) {
			this.ns.showWarnMessage('Please select at least one policy');
			return;
		}

		this.applyInProcess = true;

		const installPolicyInfo: any = {
			action: 'install',
			type: 'specific',
			fromAdmin: this.selectedFromAdmin.email,
			admins: [this.gs.controlAdmin?.email],
			policy: this.policy
		};

		// CC: taken from apply-policy.component.ts -> installPolicyExecute
		if (this.appendMode) {
			installPolicyInfo.append = true;
		}

		this.rs.installPolicy(installPolicyInfo).then(() => {
			this.ns.showInfoMessage('Policy copied successfully');
			this.applyInProcess = false;
			this.done.emit();
		}, () => {
			this.applyInProcess = false;
		});
	}
}
